/* Formaë — Custom JS v2 */

(function () {
  'use strict';

  /* ── REVEAL ON SCROLL ──────────────────── */
  function initReveal() {
    if (document.querySelector('main[data-template="index"]')) return; // la home est animée par formae-motion.js (GSAP)
    const els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('f-revealed');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach((el) => io.observe(el));
  }

  /* ── STAT COUNTER ──────────────────────── */
  function initCounters() {
    const items = document.querySelectorAll('.formae-stats__number');
    if (!items.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            animateCounter(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    items.forEach((el) => {
      el.dataset.target = el.textContent.trim();
      io.observe(el);
    });
  }

  function animateCounter(el) {
    const raw = el.dataset.target || '';
    // Extract leading number, keep suffix ("+", " / 5", " ans")
    const match = raw.match(/^([\d,.]+)(.*)/);
    if (!match) return;

    const numStr = match[1].replace(',', '.');
    const target = parseFloat(numStr);
    const suffix = match[2];
    const hasDecimal = numStr.includes('.');
    const decimalPlaces = hasDecimal ? (numStr.split('.')[1] || '').length : 0;
    const duration = 1200;
    const start = performance.now();

    function step(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // Ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;
      el.textContent = (hasDecimal
        ? current.toFixed(decimalPlaces)
        : Math.floor(current).toString()
      ) + suffix;

      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = raw; // restore exact original
    }

    requestAnimationFrame(step);
  }

  /* ── SMOOTH FAQ ────────────────────────── */
  function initFaq() {
    const items = document.querySelectorAll('.formae-faq__item');
    items.forEach((details) => {
      const summary = details.querySelector('.formae-faq__question');
      const answer = details.querySelector('.formae-faq__answer');
      if (!summary || !answer) return;

      summary.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = details.hasAttribute('open');

        // Close siblings
        items.forEach((other) => {
          if (other !== details && other.hasAttribute('open')) {
            other.removeAttribute('open');
          }
        });

        if (isOpen) {
          details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
        }
      });
    });
  }

  /* ── BUTTON HOVER SOUND EFFECT (subtle) ── */
  /* (no audio — just ensuring cursor feedback is snappy) */

  /* ── INIT ───────────────────────────────── */
  function init() {
    initReveal();
    initCounters();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', init);
})();

/* =============================================
   Testimonials video — swap main with thumbnail
   ============================================= */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-testimonials-root]').forEach((root) => {
    const mainVideo = root.querySelector('[data-testimonials-main]');
    const nameEl = root.querySelector('[data-testimonials-name]');
    const cityEl = root.querySelector('[data-testimonials-city]');
    const buttons = root.querySelectorAll('[data-testimonials-swap]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const src = button.dataset.videoSrc;
        const poster = button.dataset.videoPoster;
        const name = button.dataset.videoName;
        const city = button.dataset.videoCity;

        if (!mainVideo) return;

        if (poster) mainVideo.setAttribute('poster', poster);
        if (src) {
          const source = mainVideo.querySelector('source');
          if (source) source.setAttribute('src', src);
          mainVideo.load();
          mainVideo.play().catch(() => {/* autoplay might be blocked */});
        }
        if (nameEl && name) nameEl.textContent = name;
        if (cityEl) cityEl.textContent = city || '';

        root.querySelectorAll('.formae-testimonials-video__thumb').forEach((li) => li.classList.remove('is-active'));
        button.closest('.formae-testimonials-video__thumb')?.classList.add('is-active');
      });
    });
  });
});
